import { Col } from 'reactstrap';
import { slide as Menu } from 'react-burger-menu';
import { lightPorcelain } from 'components/style/Colors.style';
import { decorator as reduxBurgerMenu } from 'redux-burger-menu';
import styled from 'styled-components';

export const MenuCol = styled(Col).attrs({
  xs: 3
})``;

export const FixedInnerCol = styled.div.attrs({
  className: 'position-fixed'
})`
  max-width: 20%;
`;

export const BurgerMenu = styled(reduxBurgerMenu(Menu)).attrs({
  className: 'pl-4'
})`
  background-color: ${lightPorcelain};

  + div div.bm-burger-button {
    visibility: hidden;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/SideMenu.style.js